import { Checkbox, FormControlLabel, FormGroup } from "@material-ui/core";
import React, { useContext } from "react";
import {
  ContainThreeContent,
  ContainFourHeader,
  ContainThreeHeader,
  ItemContent,
  ItemHeader,
  GeneralWrapper,
} from "./AdditionalDataPanel.styled";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { NotificationManager } from "react-notifications";
import PropTypes from "prop-types";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { GreenSwitch } from "../../helpers/greenSwitch";

const AdditionalDataPanel = ({
  idForm,
  additionalData,
  additionalDataPreview,
  handleToggleCheckedAdd,
  handleMandatory,
}) => {
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);
  const addQuestion = (type, isEdit = true) => {
    if (
      stateQuestionsReducer.additionalQuestions.filter(
        (f) => f.GisEdit === true
      ).length
    ) {
      NotificationManager.warning(
        "All questions must be saved before to add another question",
        "",
        5000
      );
      return;
    }
    dispatch({
      type: "ADD_ADDITIONAL_QUESTIONS",
      payload: {
        Gtype: type,
        GindexQuestion: stateQuestionsReducer.additionalQuestions.length,
        Gactive: true,
        GidSurvey: idForm,
        GidQuestion: 0,
        GidCategoryQuestion: 0,
        GnameQuestion: "",
        GvalidationText: "",
        GidQuestionSurvey: 0,
        GisMandatory: false,
        GjsonConfiguration: "",
        Gorder: stateQuestionsReducer.additionalQuestions.length + 1,
        GisEdit: isEdit,
        GisDependent: false,
        GidParentQuestion: null,
        GdependentAnswer: null,
      },
    });
  };

  let handleOnChangeMandatory = (e, item, listId) => {
    let found = additionalDataPreview.find(
      (f) => f.idAdditionalDataList === listId
    )?.isMandatory;
    if (e?.target?.checked && found === false) {
      let mandatory = true;
      handleMandatory(item.questionType, listId, idForm, mandatory);
    } else {
      let mandatory = false;
      handleMandatory(null, listId, idForm, mandatory);
    }
  };

  let handleOnChangeAdded = (e, item, listId) => {
    const questionDetails = [item];
    if (item?.idPolicyFormAdditionalDataList === 3) {
      questionDetails.push({
        idPolicyFormAdditionalDataList: 7,
        listTitle: "Sub-Policies",
      });
    }
    let found =
      additionalDataPreview.find((f) => f.idAdditionalDataList === listId)
        ?.idAdditionalDataList === listId;
    if (e?.target?.checked && found === false) {
      handleToggleCheckedAdd(item.questionType, item, idForm, questionDetails);
    } else {
      let index = additionalDataPreview.find(
        (f, i) => f.idAdditionalDataList === listId && i
      );
      if (index !== -1) {
        additionalDataPreview.splice(index, 1);
        handleToggleCheckedAdd(null, item, idForm, questionDetails);
      }
    }
  };

  let handleOnChangeAddedFiles = (e, item) => {
    let found =
      additionalDataPreview.find((f) => f.questionType === item)
        ?.questionType === item;
    if (e?.target?.checked && found === false) {
      handleToggleCheckedAdd(item, null, idForm);
    } else {
      let index = additionalDataPreview.find(
        (f, i) => f.questionType === item && i
      );
      if (index !== -1) {
        additionalDataPreview.splice(index, 1);
        handleToggleCheckedAdd(item, null, idForm);
      }
    }
  };

  let handleOnChangeMandatoryFiles = (e, item) => {
    let found = additionalDataPreview.find(
      (f) => f.questionType === item
    )?.isMandatory;
    if (e?.target?.checked && found === false) {
      let mandatory = true;
      handleMandatory(item, null, idForm, mandatory);
    } else {
      let mandatory = false;
      handleMandatory(item, null, idForm, mandatory);
    }
  };

  let renderAdditionalList = (item, listId) => {
    let item_added =
      additionalDataPreview.length >= 1 &&
      additionalDataPreview.find((f) => f.idAdditionalDataList === listId)
        ?.idAdditionalDataList === listId
        ? true
        : false;
    let item_mandatory =
      additionalDataPreview.length >= 1 &&
      additionalDataPreview.find((f) => f.idAdditionalDataList === listId)
        ?.isMandatory === true
        ? true
        : false;
    switch (item?.listTitle) {
      case "Primary Benefit":
        return (
          <>
            <ItemContent>Primary Benefit</ItemContent>
            <ItemContent>
              <FormControlLabel
                control={
                  <GreenSwitch
                    size="small"
                    checked={item_added}
                    onChange={(e) => handleOnChangeAdded(e, item, listId)}
                  />
                }
              />
            </ItemContent>
            <ItemContent>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={item_mandatory}
                      onChange={(e) => handleOnChangeMandatory(e, item, listId)}
                    />
                  }
                />
              </FormGroup>
            </ItemContent>
          </>
        );
      case "Secondary Benefit":
        return (
          <>
            <ItemContent>Secondary Benefit</ItemContent>
            <ItemContent>
              <FormControlLabel
                control={
                  <GreenSwitch
                    size="small"
                    checked={item_added}
                    onChange={(e) => handleOnChangeAdded(e, item, listId)}
                  />
                }
              />
            </ItemContent>
            <ItemContent>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={item_mandatory}
                      onChange={(e) => handleOnChangeMandatory(e, item, listId)}
                    />
                  }
                />
              </FormGroup>
            </ItemContent>
          </>
        );
      case "Impacted Policies":
        return (
          <>
            <ItemContent>Impacted policy/ policies</ItemContent>
            <ItemContent>
              <FormControlLabel
                control={
                  <GreenSwitch
                    size="small"
                    checked={item_added}
                    onChange={(e) => handleOnChangeAdded(e, item, listId)}
                  />
                }
              />
            </ItemContent>
            <ItemContent>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={item_mandatory}
                      onChange={(e) => handleOnChangeMandatory(e, item, listId)}
                    />
                  }
                />
              </FormGroup>
            </ItemContent>
          </>
        );
      case "Impacted Queues":
        return (
          <>
            <ItemContent>Impacted queue/ queues</ItemContent>
            <ItemContent>
              <FormControlLabel
                control={
                  <GreenSwitch
                    size="small"
                    checked={item_added}
                    onChange={(e) => handleOnChangeAdded(e, item, listId)}
                  />
                }
              />
            </ItemContent>
            <ItemContent>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={item_mandatory}
                      onChange={(e) => handleOnChangeMandatory(e, item, listId)}
                    />
                  }
                />
              </FormGroup>
            </ItemContent>
          </>
        );
      case "Applicable Market":
        return (
          <>
            <ItemContent>Applicable market (s)</ItemContent>
            <ItemContent>
              <FormControlLabel
                control={
                  <GreenSwitch
                    size="small"
                    checked={item_added}
                    onChange={(e) => handleOnChangeAdded(e, item, listId)}
                  />
                }
              />
            </ItemContent>
            <ItemContent>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={item_mandatory}
                      onChange={(e) => handleOnChangeMandatory(e, item, listId)}
                    />
                  }
                />
              </FormGroup>
            </ItemContent>
          </>
        );
      case "Time Unit":
        return (
          <>
            <ItemContent>Time Unit</ItemContent>
            <ItemContent>
              <FormControlLabel
                control={
                  <GreenSwitch
                    size="small"
                    checked={item_added}
                    onChange={(e) => handleOnChangeAdded(e, item, listId)}
                  />
                }
              />
            </ItemContent>
            <ItemContent>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={item_mandatory}
                      onChange={(e) => handleOnChangeMandatory(e, item, listId)}
                    />
                  }
                />
              </FormGroup>
            </ItemContent>
          </>
        );
      case "Insights POC":
        return (
          <>
            <ItemContent>Add insights POC</ItemContent>
            <ItemContent>
              <FormControlLabel
                control={
                  <GreenSwitch
                    size="small"
                    checked={item_added}
                    onChange={(e) => handleOnChangeAdded(e, item, listId)}
                  />
                }
              />
            </ItemContent>
            <ItemContent>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked={item_mandatory}
                      onChange={(e) => handleOnChangeMandatory(e, item, listId)}
                    />
                  }
                />
              </FormGroup>
            </ItemContent>
          </>
        );

      default:
        break;
    }
  };

  let renderAditionalDataFile = (item) => {
    if (item === "File") {
      let item_added =
        additionalDataPreview.length >= 1 &&
        additionalDataPreview.find((f) => f.questionType === item)
          ?.questionType === item
          ? true
          : false;
      let item_mandatory =
        additionalDataPreview.length >= 1 &&
        additionalDataPreview.find((f) => f.questionType === item)
          ?.isMandatory === true
          ? true
          : false;
      return (
        <>
          <ItemContent>Additional files</ItemContent>
          <ItemContent>
            <FormControlLabel
              control={
                <GreenSwitch
                  size="small"
                  checked={item_added}
                  onChange={(e) => handleOnChangeAddedFiles(e, item)}
                />
              }
            />
          </ItemContent>
          <ItemContent>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={item_mandatory}
                    onChange={(e) => handleOnChangeMandatoryFiles(e, item)}
                  />
                }
              />
            </FormGroup>
          </ItemContent>
        </>
      );
    }
  };

  return (
    <>
      <ContainThreeHeader>
        <ItemHeader>List</ItemHeader>
        <ItemHeader>Add</ItemHeader>
        <ItemHeader>Mandatory?</ItemHeader>
      </ContainThreeHeader>
      <ContainThreeContent>
        {additionalData.map((item) => {
          return renderAdditionalList(
            item,
            item.idPolicyFormAdditionalDataList
          );
        })}
      </ContainThreeContent>
      <ContainFourHeader>
        <ItemHeader>Free text field</ItemHeader>
      </ContainFourHeader>
      <GeneralWrapper
        onClick={() => {
          addQuestion("FreeText");
        }}
      >
        Open Text
        <BorderColorIcon></BorderColorIcon>
      </GeneralWrapper>
      <ContainThreeHeader>
        <ItemHeader>Additional files</ItemHeader>
        <ItemHeader>Add</ItemHeader>
        <ItemHeader>Mandatory?</ItemHeader>
      </ContainThreeHeader>
      <ContainThreeContent>
        {renderAditionalDataFile("File")}
      </ContainThreeContent>
    </>
  );
};

export default AdditionalDataPanel;

AdditionalDataPanel.propTypes = {
  idForm: PropTypes.number.isRequired,
  additionalData: PropTypes.array.isRequired,
  additionalDataPreview: PropTypes.array.isRequired,
  handleToggleCheckedAdd: PropTypes.func,
  handleMandatory: PropTypes.func,
};
